import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DashboardUpdate from './dashboard-update';
import Dashboard from './dashboard';

const DashboardRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Dashboard />} />
    <Route path="new" element={<DashboardUpdate />} />
    <Route path=":id/edit" element={<DashboardUpdate />} />
    <Route path="dashboard/:id" element={<DashboardUpdate />} />
    <Route path=":id">
    </Route>
  </ErrorBoundaryRoutes>
);

export default DashboardRoutes;
